<template>
  <v-card :loading="loading" class="havet-card" elevation="2">
    <div class="top-row">
      <h4>{{ title }}</h4>
    </div>
    <div class="list mt-2">
      <div class="list-item" v-for="item in items" :key="item.id" @click="onClick(item)">
        <div class="news-title">
          <v-chip class="mr-2" label pill small :color="item.article_status | labelColor">
            {{ item.article_status | label }}
          </v-chip>
          <v-tooltip top dark>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on"> {{ item.article_title }}</span>
            </template>
            <span>{{ item.article_title }}</span>
          </v-tooltip>
        </div>
        <div class="news-date">{{ item.updated_at | prettyDate }}</div>
      </div>
    </div>
    <div class="pagination-container">
      <slot name="pagination"></slot>
    </div>
  </v-card>
</template>

<script>
import { format, parseISO } from 'date-fns'
import { getColor } from '@/assets/data/colors'

export default {
  name: 'LatestReports',
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    items: {
      type: [Array, Object],
    },
    title: String,
  },
  filters: {
    prettyDate(date) {
      try {
        return format(parseISO(date), 'yyyy-MM-dd')
      } catch (err) {
        return date
      }
    },
    label(status) {
      if (status === 'offline') return 'offline'
      if (status === 'online') return 'online'
      return ''
    },
    labelColor(status) {
      return getColor(status)
    },
  },
  methods: {
    onClick(report) {
      this.$emit('report:goto', report)
    },
  },
}
</script>

<style lang="less" scoped>
.havet-card {
  width: 100%;
  max-width: 100%;
  .top-row {
    padding-left: 15px;
    padding-top: 12px;
  }
  .list {
    font-size: 0.9rem;
    overflow: auto;
    max-height: 100%;
    .list-item {
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      padding: 6px 15px;
      border-bottom: #ccc 1px solid;
      .news-title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .news-date {
        margin-left: 10px;
        white-space: nowrap;
      }
      // border
    }
  }
  .pagination-container {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
